module.exports = __webpack_public_path__ + "static/media/chelsea.dec24887.png";